<div class="container">
  <div style="margin-top:100px">
    <div class="text-center">
      <a (click)="LoginWithMinside()" id="minsideLogin" style="color: rgba(0,0,0,.5);font-size:22px;  border-radius: 20;
      border: 1px solid #012C1E;background-color: #B1CF91; padding:5px 10px;cursor: pointer;">
        Klikk å fortsette
      </a>
    </div>
  </div>
</div>